<script>
    import { createCompany } from "../../Company.svelte";
    import Reporter from "../../lib/error.js";

    import Dialog from "../Dialog.svelte";
    import Name from "../Name.svelte";
    import Emoji from "../Emoji.svelte";
    import Field from "../form/Field.svelte";
    import TextField from "../form/TextField.svelte";
    import UrlField from "../form/UrlField.svelte";
    //import ImageUploadField from "../form/ImageUploadField.svelte";
    import CloudinaryImageUpload from "../form/CloudinaryImageUpload.svelte";
    import Button from "../form/Button.svelte";
    import Messages from "../form/Messages.svelte";
    import Message from "../form/Message.svelte";
    import LoadingModal from "../LoadingModal.svelte";

    import {Label} from '@smui/button';
    import Icon from '@smui/textfield/icon/index';
    import HelperText from '@smui/textfield/helper-text/index';
    import {Icon as CommonIcon} from '@smui/common';
    import FloatingLabel from '@smui/floating-label';
    import LineRipple from '@smui/line-ripple';
    import NotchedOutline from '@smui/notched-outline';

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let show = true;

    export let name = "";
    export let websiteUrl = "";
    export let logoUrl = "";
    export let eyeventureUrl = "http://eyevestor.com/eyeventure/placeholder/url";

    $: newCompanyStruct = {
        name, websiteUrl, eyeventureUrl
    };

    let submitRequest;
    let errorResult;

    // send data and create entity
    function create() {
        console.log(`preparing to create company using ${JSON.stringify(newCompanyStruct)}`);

        submitRequest = createCompany(newCompanyStruct)
            // it worked!
            .then(res => {
                console.log(`successfully created company:`);
                console.log(res);

                // TODO: this is a temporary hack to get a company picture to show up
                // on the same computer that created it, until JVT includes this field
                // in the graphql schema
                console.log("TODO: temporarily storing company picture to localStorage until GraphQL field is supported");
                localStorage.setItem(`${res.data.addCompany.id}.logo`, logoUrl);
                dispatch("new", res.data);
            })
            // oh shit
            .catch(res => {
                Reporter.error("[NewCompanyDialog] error trying to create company", res);
                errorResult = res;
                return false;
            });

        return false;
    }
</script>

<Dialog {show}>
    <h1>New Company <Emoji name="office"/></h1>
    <p>
        Let's define a new company.
    </p>
    <form>
        <Messages>
            {#if !errorResult}

            {:else if (JSON.stringify(errorResult).includes("Company was already registered"))}
                <Message style="padding: 10px;">A company with this name already exists. Please choose a different name.</Message>
            {:else}
                <Message style="padding: 10px;">There was an error trying to create the company. Please contact support.</Message>
            {/if}
        </Messages>
        <Field>
            <TextField
                    bind:value={name}
                    label="Company name"
                    help="Unique name of your (hypothetical) company. Can still be changed later"
                    style="width: 100%"
            />
        </Field>
        <Field>
            <UrlField
                    bind:value={websiteUrl}
                    label="Website URL"
                    help="URL of the company website (optional)"
                    style="width: 100%"
            />
        </Field>
<!--        <Field outline={true} help="Configure the logo of the company. Will be used in your dashboard">-->
<!--            <ImageUploadField-->
<!--                    bind:value={logoUrl}-->
<!--                    label="Logo URL"-->
<!--                    help=""-->
<!--                    style="width: 100%"-->
<!--            />-->
<!--        </Field>-->
        <Field outline={true} help="Configure the logo or company image. This will be used in the dashboard">
            <CloudinaryImageUpload
                    bind:url={logoUrl}
                    cropRatio="1.5" />

            {#if logoUrl}
                <img src={logoUrl} style="max-height: 100px;"/>
            {/if}
        </Field>
    </form>
    <Button id="button-step1" on:click={create} disabled={!name || !websiteUrl}>
        <Label>Create this company</Label>
    </Button>

    <!-- show loading modal while request is in flight -->
    {#await submitRequest}
        <LoadingModal global={false}/>
    {/await}
</Dialog>

<style>
    form {
        margin: 25px 0;
    }

    p {
        text-align: center;
        margin: 25px 0;
    }

    :global(#button-step1) {
        margin: auto;
        //margin-top: 50px;
        display: inherit;
    }
</style>